import { AbstractSceneTransition } from "slotworks/graphics/layers/scene-transitions/abstract-scene-transition";
import { BounceZoomIn, BounceZoomOut } from "slotworks/graphics/animation/base-animations";
import Layers from "slotworks/graphics/layers/layers";
import { PIXIElement, CenterPivot, Ungroup } from "slotworks/graphics/pixi/group";
import Contract from "slotworks/utils/contract";
import * as TweenJS from "slotworks/utils/tween";
import Point from "slotworks/utils/geom/point";
import { sequence, parallel } from "slotworks/utils/race-utils";
import { AddParticle } from "util/tools";
import { Sprite, Container } from "pixi.js";
import Timer from "slotworks/utils/timer";
import canvasManager, { Orientation } from "slotworks/graphics/canvas/canvas-manager";

export default class BonusAwardTransition extends AbstractSceneTransition {

    private container: Container;

    public in(): Contract<void>{
        //
        const starsine = Layers.Prompts.getAnimatedSprite("starshine_win_loop");
        sequence([
            () => BounceZoomIn(starsine, 500, 100),
            () => BounceZoomOut(starsine, 500, 400)
        ]).then(() => {
            starsine.stop();
            starsine.visible = false;
        });
        
        const plaque = Layers.Prompts.container.children[0] as Sprite;
        const x = plaque.x + plaque.width/2;
        const y = plaque.y + plaque.height/2;

        this.container = CenterPivot(Layers.Prompts.container.children as PIXIElement[]);
        this.container.scale.set(0, 0);

        Timer.setTimeout(() => {
            const emitter = AddParticle("glitter_explosion_medium", Layers.Prompts);
            emitter.spawnPos.set(x, y);
            emitter.emit = true;

            Timer.setTimeout(() => emitter.emit = false, 400);
        }, 200);
        return new Contract(resolve => {
            new TweenJS.Tween(this.container.scale)
            .to({x: 1, y: 1}, 400)
            .easing(TweenJS.Easing.Back.Out)
            .onComplete(resolve)
            .start();
        });
    }

    public out(): Contract<void> {
        if(canvasManager.orientation == Orientation.PORTRAIT) {
            return new Contract<void>(resolve => {
                new TweenJS.Tween(this.container.scale)
                .to({x: 0, y: 0}, 300)
                .onComplete(() => {
                    for(let child of this.container.children) 
                        child.visible = false;
                    Ungroup(this.container);
                    this.container = null;
                    resolve(null);
                })
                .start();
            });
        }
        return new Contract<void>(resolve => {
            const y = Layers.Prompts.globalToLocal(new Point(0, -400)).y;
            new TweenJS.Tween(this.container)
            .to({y: y}, 500)
            .onComplete(() => {
                Ungroup(this.container);
                this.container = null;
                resolve(null);
            })
            .start();
        });
    }

}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/transitions/bonus-award-transition.ts